import { createCustomServiceCall } from '@thinknimble/tn-models'
import { z } from 'zod'
import { axiosInstance } from '../axios-instance'
import { notificationPreferenceShape } from './models'

export const listPreferences = createCustomServiceCall.standAlone({
  client: axiosInstance,
  models: {
    outputShape: z.array(z.object(notificationPreferenceShape)),
  },
  cb: async ({ client, utils: { fromApi } }) => {
    const response = await client.get('/notifications/preferences/')
    return response.data.map((item: Record<string, unknown>) => fromApi(item))
  },
})

export const updatePreferenceToggle = createCustomServiceCall.standAlone({
  client: axiosInstance,
  models: {
    inputShape: {
      eventType: z.string(),
      channel: z.enum(['in_app', 'email', 'whatsapp']),
      enabled: z.boolean(),
    },
    outputShape: notificationPreferenceShape,
  },
  cb: async ({ client, input, utils: { fromApi, toApi } }) => {
    const response = await client.patch('/notifications/preferences/', toApi(input))
    return fromApi(response.data)
  },
})
